export default __webpack_public_path__ + "static/media/yellowTheme-girl.4579de4e.svg";